import { Component, Input, AfterViewInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { environment } from '@environments/environment';

declare let shaka: any;

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements AfterViewInit, OnChanges, OnDestroy {
  public readonly poster = 'assets/images/video-loading.png';

  @Input() playVideo: boolean;

  @Input() source: string;

  @Input() id: number;

  player: any;

  ngAfterViewInit() {
    this.initApp();
  }

  initApp() {
    // Install built-in polyfills to patch browser incompatibilities.
    shaka.polyfill.installAll();

    // Check to see if the browser supports the basic APIs Shaka needs.
    if (shaka.Player.isBrowserSupported()) {
      // Everything looks good!
      this.initPlayer();
    } else {
      // This browser does not have the minimum set of APIs we need.
      console.error('Browser not supported!');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const video: any = document.getElementById(`video-${this.id}`);
    if (video) {
      if (changes.playVideo.currentValue !== changes.playVideo.previousValue) {
        if (changes.playVideo.currentValue) {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  initPlayer() {
    const manifestUri = environment.apiVideoUrl + this.source;
    // Create a Player instance.
    const video: any = document.getElementById(`video-${this.id}`);
    this.player = new shaka.Player(video);
    this.player.configure('manifest.defaultPresentationDelay', 0);
    this.player.addEventListener('error', this.onErrorEvent);
    this.player.configure({
      streaming: {
        lowLatencyMode: true,
        inaccurateManifestTolerance: 0,
        rebufferingGoal: 0.01,
      },
    });
    this.player.load(manifestUri).then().catch(this.onError);

    if (this.playVideo) {
      video.play();
    }
  }

  onErrorEvent(event: any) {
    // Extract the shaka.util.Error object from the event.
    this.onError(event.detail);
  }

  onError(error: any) {
    // Log the error.
    console.error('Error code', error.code, 'object', error);
  }

  ngOnDestroy() {
    this.player.destroy();
  }
}
